import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createUnit',
    serviceName: 'admin',
    query: gql`
      mutation createUnit($title: String!, $manager_id: String, $lat: String, $lng: String, $is_active: Int) {
        createUnit(title: $title, manager_id: $manager_id, lat: $lat, lng: $lng, is_active: $is_active) {
          messages
        }
      }
    `,
  },
};

export default schema;
